
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8f3d1a70&scoped=true!less-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./HotArticleList.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HotArticleList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8f3d1a70!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HotArticleList.vue"),
  /* scopeId */
  "data-v-8f3d1a70",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/article/HotArticleList.vue
// module id = 952
// module chunks = 40